import { useState, useRef, useEffect, useCallback } from 'react';
import * as React from 'react';
import getComponentName from 'react-utils/getComponentName';
import { Map as ImmutableMap } from 'immutable';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function pannableDecorator(WrappedComponent) {
  const PannableDecorator = props => {
    const {
      scrollElementRef
    } = props;
    const [isDragging, setIsDragging] = useState(false);
    const initialCoordinateValues = ImmutableMap({
      dragStartX: null,
      dragStartY: null,
      initialScrollLeft: null,
      initialScrollTop: null
    });
    const mutableCoordinateValues = useRef(initialCoordinateValues);
    const handleMouseUp = () => {
      mutableCoordinateValues.current = initialCoordinateValues;
      setIsDragging(false);
    };
    const handleMouseDown = useCallback(event => {
      const scrollContainer = scrollElementRef.current;
      if (!scrollContainer) {
        return;
      }
      mutableCoordinateValues.current = ImmutableMap({
        dragStartX: event.clientX,
        dragStartY: event.clientY,
        initialScrollLeft: scrollContainer.scrollLeft,
        initialScrollTop: scrollContainer.scrollTop
      });
      setIsDragging(true);
    }, [scrollElementRef]);
    const handleMouseMove = ({
      clientX,
      clientY
    }) => {
      const scrollContainer = scrollElementRef.current;
      if (!isDragging || !scrollContainer) {
        return;
      }
      const dx = clientX - (mutableCoordinateValues.current.get('dragStartX') || 0);
      const dy = clientY - (mutableCoordinateValues.current.get('dragStartY') || 0);
      scrollContainer.scrollLeft = (mutableCoordinateValues.current.get('initialScrollLeft') || 0) - dx;
      scrollContainer.scrollTop = (mutableCoordinateValues.current.get('initialScrollTop') || 0) - dy;
    };
    useEffect(() => {
      // Attach a window event listener for 'mouseup' so that we receive any mouseup
      // that occurs even if the mouse is inside the browser window, over another
      // element, etc. This prevents 'sticky' drags which continue if you release
      // the mouse outside the browser window.
      window.addEventListener('mouseup', handleMouseUp);
      return () => window.removeEventListener('mouseup', handleMouseUp);
    });
    return /*#__PURE__*/_jsx("div", {
      className: `pannable-container width-100 ${isDragging ? 'grabbing' : ''}`,
      onMouseDown: handleMouseDown,
      onMouseMove: handleMouseMove,
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
    });
  };
  const componentName = getComponentName(WrappedComponent);
  PannableDecorator.displayName = `PannableDecorator(${componentName})`;

  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  PannableDecorator.defaultProps = WrappedComponent.defaultProps;
  attachWrappedComponent(PannableDecorator, WrappedComponent);
  return PannableDecorator;
}